import {useQueryClient} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {useResendTimerQuery} from '../../queries/useResendTimerQuery';

export function useResendTimer() {
	const queryClient = useQueryClient();
	const {data: timerData} = useResendTimerQuery();

	const setTimerData = (data: {timer: number; startTime: number; isAvailable: boolean}) => {
		queryClient.setQueryData([QUERY_KEYS.RESEND_TIMER], data);
	};

	const resetTimer = () => {
		const newTimerData = {
			timer: 300,
			startTime: Date.now(),
			isAvailable: false,
		};
		setTimerData(newTimerData);
	};

	return {
		timerData: timerData || {timer: 300, startTime: Date.now(), isAvailable: false},
		setTimerData,
		resetTimer,
	};
}
